const { Vue, jQuery: $ } = window;

import {
	getBuildChanges,
	generateBuilderUI,
	leadFormData
} from "../_utilities";
import { ACTIONS } from "../_actions";
import { store, store$ } from "../_config-store";
import { localize } from "../_localize.js";

const activeOptionChildren$ = store$
	.map(state => state.activeOptionChildren);

const activeOption$ = store$
	.map(state => state.activeOption);

const viewOptions$ = store$
	.map(state => state.viewOptions);

const truckModel$ = store$
	.map(state => state.truckModel);

export const options = {
	template:
		`<div id="modal-dialog">
		<header>
			<h6>{{local('Step')}} {{stepNormalized}} {{local('of')}} {{totalSteps}}</h6>
			<h1 v-if="!stepTitleOverride">{{stepTitle}}</h1>
			<h1 v-if="stepTitleOverride">{{stepTitleOverride}}</h1>
		</header>
		<div option-container>
			<template v-for="option in availableOptions">
				<item-card :class="{included: option.included}"
					v-if="option.included" 
					v-on:click.native="setOption(option)"
					v-bind:selected="option.attributes.checked"
					v-bind:parent="option.component"
					v-bind:label="option.component"
					v-bind:sub-label="option.label"
					v-bind:optionObj="option"
					v-bind:optionKey="option.attributes['data-key']"
					v-bind:firstOption="option.attributes['first-option-key']"
				></item-card>
				<item-card
					v-else 
					v-on:click.native="setOption(option)"
					v-bind:selected="option.attributes.checked"
					v-bind:parent="option.component"
					v-bind:label="option.label"
					v-bind:optionObj="option"
					v-bind:optionKey="option.attributes['data-key']"
					v-bind:firstOption="option.attributes['first-option-key']"
				></item-card>
				<!--<item-card v-else-if="option.current" class="included"-->
					<!--v-bind:label="option.label"-->
					<!--v-bind:sub-label="option.current"-->
					<!--v-bind:icon="optionClass(option.options[0].component + '-test-' + option.options[0].attributes['data-name'])"-->
					<!--v-bind:optionKey="option.options[0] && option.options[0].attributes ? option.options[0].attributes['data-key'] : undefined"-->
					<!--v-bind:firstOption="option.options[0] && option.options[0].attributes ? option.options[0].attributes['first-option-key'] : undefined"-->
				<!--&gt;</item-card>-->
			</template>
		</div>
		<div actions v-if="showActions">
			<button v-on:click="cancel" cancel key="cancel">{{local('Cancel')}}</button>
			<button v-if="totalSteps && step > 0" v-on:click="prev" prev key="prev">{{local('Prev')}}</button>
			<button v-if="totalSteps && stepNormalized < totalSteps" v-on:click="next" next key="next">{{local('Next')}}</button>
			<button v-else v-on:click="select" select key="select">{{local('Select')}}</button>
			<button quote @click="getQuote" key="quote">{{summaryLabel}}</button>
		</div>
	</div>`,
	data() {
		return {
			step: 0,
			showActions: true,
			leadForm: leadFormData(),
			local(str){
				return str;
			}
		};
	},
	subscriptions() {
		return {
			activeOptionChildren: activeOptionChildren$,
			activeOption: activeOption$,
			viewOptions: viewOptions$,
			truckModel: truckModel$,
			store: store$
		};
	},
	computed: {
		steps() {
			let avl = _.chain(this.activeOptionChildren).groupBy(item => {
				return item.options.length === 1 ? 'included' : 'available';
			}).value();

			let options = (avl.available || []).concat(avl.included ? [{
				label: this.local('Included'),
				options: _.chain(avl.included)
					.map(incl => incl.options)
					.flatten()
					.map(option => Object.assign({}, option, {included: true}))
					.value()
			}] : []);
			return options;
		},
		summaryLabel() {
			// ADHOC METHOD TO CHANGE BUTTON TEXT IF HIDEFORM IS TRUE
			if (window.hideForm === 'True') {
				return this.local('View Summary');
			} else {
				return this.leadForm ? this.leadForm.SubmitLabel : this.local('Get a Quote');
			}
		},
		stepNormalized() {
			return this.step + 1;
		},
		totalSteps() {
			return this.steps.length;
		},
		stepTitle() {
			return this.steps[this.step].label || this.steps[this.step].options[0].component;
		},
		availableOptions() {
			return this.steps[this.step].options;
		},
		currentOption() {
			return this.steps[this.step];
		},
		stepTitleOverride() {
			// ADHOC METHOD TO OVERRIDE THE GENERIC INCLUDED TITLE
			if (this.truckModel == "M2 106 Plus") {
				if (this.step == 1 && this.steps.length == 2 && this.activeOption == "Safety") {
					return "Suite of Safety Systems";
				} else if (this.step == 0 && this.steps.length == 1) {
					console.log('ALT');
					return "Suite of Safety Systems";
                }
            }
        }
	},
	watch: {
		step() {
			$('[option-container]').scrollLeft(0);
		}
	},
	methods: {
		cancel() {
			store.dispatch({
				type: ACTIONS.SET_CHILDREN_ACTIVE,
				data: false
			});
		},
		optionSelect() {
			if (this.stepTitle === this.local('Included')) {

				this.availableOptions.forEach((option) => {
					if (option.current) {
						store.dispatch({
							type: ACTIONS.OPTION_SELECT,
							cat: option.label,
							option: "INCL: " + option.currentKey
						});
					}
				});
			}
			else {
				store.dispatch({
					type: ACTIONS.OPTION_SELECT,
					cat: this.currentOption.label,
					option: this.currentOption.currentKey
				});
			}

		},
		select() {
			this.optionSelect();
			store.dispatch({
				type: ACTIONS.OPTION_INTERACTED
			});
			store.dispatch({
				type: ACTIONS.ACTIVE_OPTION_CHANGE,
				data: ''
			});
			store.dispatch({
				type: ACTIONS.BUILD_SETTINGS_BACKUP_CLEAR
			});
			store.dispatch({
				type: ACTIONS.SET_CHILDREN_ACTIVE,
				data: false
			});
		},

		next() {
			this.optionSelect();
			this.step++;
			this.rerender();

		},
		prev() {
			this.step--;
			this.rerender();
		},
		setOption(option) {
			let component = option.attributes['data-component'],
				key = option.attributes['data-key'];

			store.dispatch(getBuildChanges(component, key));

			if (option.altWorkflow) {
				let state = this.store;
				let builderUI = generateBuilderUI(this.store)
					.filter(group => group.altWorkflow === option.parent || group.altWorkflow === option.altWorkflow);
				let optionChildren = _.pickBy(builderUI[0].options, (component, key) => {
					return component && key !== component.altWorkflow;
				});
				store.dispatch({
					type: ACTIONS.SET_OPTION_CHILDREN,
					data: optionChildren
				});
			}
		},
		getQuote() {
			let option = this.viewOptions[_.findIndex(this.viewOptions, { id: 'misc' })];
			if (option) {
				store.dispatch({
					type: ACTIONS.VIEW_OPTION_CHANGE,
					data: option.name
				});
			}
			store.dispatch({
				type: ACTIONS.SET_CHILDREN_ACTIVE,
				data: false
			});
			store.dispatch({
				type: ACTIONS.ACTIVE_OPTION_CHANGE,
				data: ''
			});
			store.dispatch({
				type: ACTIONS.BUILD_SETTINGS_RESTORE
			});
			store.dispatch({
				type: ACTIONS.ACTIVE_SUMMARY_CHANGE,
				data: true
			});


		},
		optionClass(optionLabel) {
			return _.kebabCase(optionLabel);
		},
		rerender() {
			this.showActions = false;
			this.$nextTick(() => {
				this.showActions = true;
				this.$nextTick(() => {
				});
			});
		}
	},
	created(){
		localize().then( local => this.local = local );
	}
};


Vue.component('modal-dialog', options);